import { modalRenderer } from '~/modal/modalRendererRegistry';
import {
  BoundaryItemSettingsContainer, type BoundaryItemSettingsProps,
} from './boundaryItemSettings.container';

declare module '~/modal/modalRegistry.type' {
  interface ModalComponentRegistry {
    BoundaryItemSettings: BoundaryItemSettingsProps;
  }
}
modalRenderer.register('BoundaryItemSettings', BoundaryItemSettingsContainer);
